import { FC, useEffect, useState } from 'react';

export enum TalrooPixel {
  CREATE_PROFILE = 'create-profile',
  COMPLETE_PROFILE = 'complete-profile',
  APPPLIED = 'applied',
}

interface TalrooProps {
  pixel: TalrooPixel;
}

export const Talroo: FC<TalrooProps> = ({ pixel }) => {
  const [src, setSrc] = useState<string>('');

  useEffect(() => {
    switch (pixel) {
      case TalrooPixel.CREATE_PROFILE:
        setSrc('https://www.jobs2careers.com/conversion.php?p=6370');
        break;
      case TalrooPixel.COMPLETE_PROFILE:
        setSrc('https://www.jobs2careers.com/conversion2.php?p=6370');
        break;
      case TalrooPixel.APPPLIED:
        setSrc('https://www.jobs2careers.com/conversion3.php?p=6370');
        break;
    }
  }, [pixel]);

  return (
    // eslint-disable-next-line jsx-a11y/alt-text
    <img src={src} width="1" height="1" />
  );
};

export default Talroo;
